import React from "react";
import clsx from "clsx";
import Paper, {PaperProps} from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import useStyles from "./styles";

type FfairPaperProps = PaperProps & {
  title?: React.ReactNode;
};

const FfairPaper: React.FC<FfairPaperProps> = ({children, title, ...props}) => {
  const classes = useStyles();

  return (
    <Paper
      {...props}
      elevation={0}
      classes={{
        ...props.classes,
        root: clsx(props.classes?.root, classes.root),
        rounded: classes.rounded,
      }}
    >
      {title && <Typography className={classes.title}>{title}</Typography>}
      {children}
    </Paper>
  );
};

export default FfairPaper;
